import { Navigate } from "react-router-dom";

//pages

//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import UsersList from "pages/User";
import Error404 from "pages/Error/Error404";
import EditUser from "pages/User/Edit";
import CreateUser from "pages/User/Create";
import TaskMilestone from "pages/Task";
import Collaborations from "pages/Collaboration";
import Dashboard from "pages/Dashboard";

// Landing Index

// User Profile

const authProtectedRoutes = [
 
  // { path: "/collaboration", component: <h6>Collaboration</h6> },
  { path: "/", component: <Dashboard /> },
  { path: "/dashbaord", component: <Dashboard /> },
  { path: "/user", component: <UsersList /> },
  { path: "/user/create", component: <CreateUser /> },
  { path: "/user/:userId", component: <EditUser /> },
  { path: "/tasks", component: <TaskMilestone /> },
  { path: "/tasks/:campaignId/influencer/:influencerId/milestone/:milestoneId", component: <TaskMilestone /> },
  { path: "/tasks/:campaignId/influencer/:influencerId", component: <TaskMilestone /> },
  { path: "/collaborations", component: <Collaborations /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/" />,
  // },
  { path: "*", component: <Error404 /> },  
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },


];

export { authProtectedRoutes, publicRoutes };